// extracted by mini-css-extract-plugin
export default {"fr-view":"GroupEdit_fr-view__pk3CB","error":"GroupEdit_error__ChtEW","field":"GroupEdit_field__8REFS","action":"GroupEdit_action__SEAyO"};